import React, { Component } from 'react';

class Home extends Component {    
    state = {}
    render() {
        return (
            <div className="main_container">
                <div className="coverpage_content">
                    <div className="background_gradient">
                        <div className="coverpage_title">
                            <h1>
                                Realiza tus solicitudes al<br/>
                                H. Consejo Académico <br/> 
                                de la Facultad de Informática 
                            </h1>
                            <h4>Unidxs para Innovar y Trascender</h4>
                        </div>
                        <div className="coverpage_button">
                            <a href="/solicitudes/tramites" className="btn btn-info">Realizar solicitud ahora</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Home;